import type { TranslationContext } from '@/util/translate/types/ctx'
import { safeProp } from '@lc/libutils'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type LanguagesSlice = {
	languageKeys: string[]
	languagePacks: Record<string, TranslationContext>
}
export const defaultLanguagesSlice: LanguagesSlice = {
	languageKeys: [],
	languagePacks: {},
}

export const languagesSlice = createSlice({
	name: 'languages',
	initialState: defaultLanguagesSlice,
	reducers: {
		languagesLoad: (
			state,
			action: PayloadAction<Record<string, TranslationContext>>,
		) => {
			for (const [id, pack] of Object.entries(action.payload)) {
				if (!('id' in state.languagePacks)) {
					// eslint-disable-next-line security/detect-object-injection
					state.languagePacks[id] = pack
					state.languageKeys.push(id)
				} else {
					// eslint-disable-next-line security/detect-object-injection
					const currentPack = state.languagePacks[id]
					Object.assign(currentPack.keys, pack.keys)
				}
			}
		},
	},
	selectors: {
		listLanguages: state => state.languageKeys,
		getLanguageData: (
			state,
			lang: string,
		): TranslationContext | undefined =>
			state.languagePacks[safeProp(lang)],
	},
})

export const {
	reducer: languagesReducer,
	actions: { languagesLoad },
	selectors: { listLanguages, getLanguageData },
} = languagesSlice
